import { useTranslation } from "react-i18next";
import useMmcService from "../../services/MmcService";
import { useContext } from "react";
import InitContext from "../pages/InitContext";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import {Consts} from "../pages/consts";
import {getPatientName} from "../pages/utils";

const PatientDataDeleteDialog = ({
  showDialog,
  patient,
  onConfirmPatientDelete,
  onCancelPatientDelete,
  onCancelDialog,
}) => {
  const { t: t } = useTranslation();

  const {
    loading,
    error,
    clearError,
    confirmDbPatientDataDelete,
    cancelDbPatientDataDelete,
  } = useMmcService();

  const context = useContext(InitContext);
  const isStudyDirector = context?.role === Consts.STUDY_DIRECTOR;

  const handleConfirmPatientDataDelete = async () => {
    clearError();
    const res = await confirmDbPatientDataDelete(context?.token, patient?.id);

    if (res) {
      onConfirmPatientDelete();
    }
  };

  const handleCancelPatientDataDelete = async () => {
    clearError();
    const res = await cancelDbPatientDataDelete(context?.token, patient?.id);

    if (res) {
      onCancelPatientDelete();
    }
  };

  const errorMessage = error && <ErrorMessage message={error} />;
  const spinner = loading && <Spinner />;

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-medium">
        <header className="w3-container w3-padding-small w3-center">
          <p>
            {t("delete_patient_data")}{" "}
            {getPatientName(patient, isStudyDirector)}
          </p>
        </header>
        {errorMessage}
        {spinner}
        <div className="w3-container w3-padding-small w3-center">
          <label>
            {t("confirm_or_withdraw_delete_patient_data_request")}.{" "}
            {t("confirm_delete_patient_data")}.
          </label>
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5"
              onClick={handleConfirmPatientDataDelete}
            >
              {t("submit")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={handleCancelPatientDataDelete}
            >
              {t("withdraw_request")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={onCancelDialog}
            >
              {t("cancel")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PatientDataDeleteDialog;
